/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { FetchThirdpartyConnectorsResponse } from './FetchThirdpartyConnectorsResponse.types.tsx';

export const servicedeskKnowledgeBaseThirdpartyConnectorsResource: RouteResource<FetchThirdpartyConnectorsResponse> =
	createResource<FetchThirdpartyConnectorsResponse>({
		type: 'SERVICEDESK_KNOWLEDGE_BASE_THIRDPARTY_CONNECTORS',
		getKey: ({ match }) => match.params.projectKey || '',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-knowledge-base-thirdparty-connectors", jiraSpaEntry: "async-resource-servicedesk-knowledge-base-thirdparty-connectors" */ './fetchThirdpartyConnectors.tsx'
			),
		maxAge: Infinity,
		isBrowserOnly: true,
	});
